<template>
    <div class="tab-pane params" id="highlightedProductProperty" role="tabpanel" aria-expanded="false">
        <div v-if="productInfo.HighlightedProductPropertyValue.length > 0" class="col-lg-4 col-md-6 col-sm-12 center-breakpoint">
            <div class="product-params default">
                <ul data-title="ویژگی‌های محصول">
                    <li></li>
                    <li v-for="Highlighted in  productInfo.HighlightedProductPropertyValue">
                        <h3 style="font-size:13px;">{{Highlighted.PropertyTitle}} : {{Highlighted.PropertyValue == null || Highlighted.PropertyValue == '' ?  '----' : Highlighted.PropertyValue }}</h3>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="productInfo.HighlightedProductPropertyValue.length < 0" class="col-lg-4 col-md-6 col-sm-12 center-breakpoint">
            <div class="product-params default">
                ویژگی برای این محصول ثبت نشده است
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            productInfo: {
                type: Object,
            },
        },
    }
</script>

<style scoped>
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .empty-media p {
            font-size: 13px;
        }
        .section-video-row {
            text-align: center;
        }
    }
</style>